import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { TransporteurType } from 'constants.js';

import AddTransporteurDialog from './AddTransporteurDialog';
import DeleteTransporteurDialog from './DeleteTransporteurDialog';
import { green } from '@mui/material/colors';



const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link, 
       
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },

    deleting: {
        background : 'red'
    },


    nowrapCell: {
        whiteSpace: 'nowrap'
    }  

});



class AdministrationTransporteurs extends React.Component {
    

    render() {

        let {
            classes, transporteurs,
            addTransporteurDialogOpen, onOpenAddDialog, onCloseAddDialog, addTransporteur,
            deleteTransporteurDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteTransporteur, transporteurToDelete
         } = this.props;

        return (
            <React.Fragment>

                {addTransporteurDialogOpen && <AddTransporteurDialog onClose={onCloseAddDialog} onClickSave={addTransporteur} />}
                {deleteTransporteurDialogOpen && <DeleteTransporteurDialog onClose={onCloseDeleteDialog} onClickDelete={deleteTransporteur} transporteur={transporteurToDelete} />}


                <div className={classes.administrationHeaderContainer}>
                    <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                        Administration des transporteurs
                    </Typography>
                    <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouveau</Button>
                </div>

                <Paper className={classes.root}>

                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='right'>Id</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Comptes</TableCell>
                                <TableCell>{`Pièces\xa0logistique`}</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transporteurs.map(transporteur => {
                                return (
                                    <TableRow key={transporteur.id} className={transporteurToDelete && transporteurToDelete.id === transporteur.id ? classes.deleting :''}
                                        hover
                                    >
                                        <TableCell component="th" scope="row" align='right'>
                                            <Link to={`/administration/transporteurs/${transporteur.id}`} className={classes.link}>
                                                <Typography variant="button">
                                                    {transporteur.id}
                                                </Typography>
                                            </Link>
                                        </TableCell>
                                        <TableCell>{transporteur.type === TransporteurType.Expressiste ? 'Expressiste' : 'Messager'}</TableCell>
                                        <TableCell>{transporteur.code}</TableCell>
                                        <TableCell className={classes.nowrapCell}>{transporteur.nom}</TableCell>
                                        <TableCell>{transporteur.comptes ? transporteur.comptes.map(x => x.compte).join(', ') : ''}</TableCell>
                                        <TableCell>{transporteur.nbPiecesLogistique}</TableCell>
                                        <TableCell>

                                            <Link to={`/administration/transporteurs/${transporteur.id}/comptes`} className={classes.link}>
                                                <Button>Editer&nbsp;comptes</Button>
                                            </Link>

                                            <Button disabled={transporteur.nbPiecesLogistique > 0} onClick={e => onOpenDeleteDialog(transporteur.id)}>Supprimer</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                </Paper>

            </React.Fragment>


        );
    }
}

AdministrationTransporteurs.propTypes = {
    classes: PropTypes.object.isRequired,
    transporteurs: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationTransporteurs);